import { ApolloClientOptions, ApolloLink, InMemoryCache } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { fetchAuthSession } from 'aws-amplify/auth';
import { AUTH_TYPE, AuthOptions, createAuthLink } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';

async function getIdToken(): Promise<string | undefined> {
  const session = await fetchAuthSession();
  return session.tokens?.idToken?.toString();
}

export function apolloFactory(httpLink: HttpLink, graphqlEndpoint: string, region: string): ApolloClientOptions<any> {
  const auth: AuthOptions = {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => (await getIdToken()) || '',
  };

  const http = httpLink.create({ uri: graphqlEndpoint });

  // AppSync auth link
  const authLink = createAuthLink({ url: graphqlEndpoint, region, auth });

  // AppSync subscription link (websocket connection)
  const subscriptionLink = createSubscriptionHandshakeLink({ url: graphqlEndpoint, region, auth }, http);

  // Combine: auth -> subscription (which includes http fallback)
  const link = ApolloLink.from([authLink, subscriptionLink]);

  return {
    link,
    cache: new InMemoryCache(),
  };
}
